module.exports = __webpack_public_path__ + "static/img/13.659841c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/13.png
// module id = yB3e
// module chunks = 0